import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ill_badge_request_pickup.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-cd50cf66")

_pushScopeId("data-v-cd50cf66")
const _hoisted_1 = { class: "inline-flex" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = { class: "w-full" }
const _hoisted_4 = { class: "flex flex-row mt-6 w-full mb-8" }
const _hoisted_5 = { class: "w-full" }
const _hoisted_6 = { class: "flex flex-row mb-8" }
const _hoisted_7 = { class: "flex flex-row w-full mb-8" }
const _hoisted_8 = { class: "flex flex-row mb-8 w-full" }
const _hoisted_9 = {
  key: 0,
  style: {"color":"#b82025 !important"}
}
const _hoisted_10 = { class: "flex flex-row w-full items-end" }
const _hoisted_11 = { class: "text-gray-lp-500 mt-1" }
const _hoisted_12 = { style: {"flex":"1"} }
const _hoisted_13 = {
  key: 0,
  class: "flex flex-row bg-red-lp-100 rounded-lg p-2 text-sm font-semibold text-white items-center",
  style: {"width":"fit-content"}
}
const _hoisted_14 = /*#__PURE__*/_createVNode("img", {
  class: "mr-2",
  src: _imports_0,
  alt: "request-pickup"
}, null, -1)
const _hoisted_15 = { class: "text-sm font-semibold text-gray-lp-300 mb-2" }
const _hoisted_16 = { class: "text-xs text-gray-lp-800 mb-2" }
const _hoisted_17 = { class: "border border-gray-lp-200 rounded-lg p-3 text-sm text-gray-lp-300" }
const _hoisted_18 = { class: "flex flex-row justify-between items-baseline mb-2" }
const _hoisted_19 = { class: "flex w-full flex-row justify-start" }
const _hoisted_20 = { class: "font-semibold flex flex-row justify-end w-full" }
const _hoisted_21 = { class: "flex flex-row justify-between items-baseline mb-2" }
const _hoisted_22 = { class: "flex w-full flex-row justify-start" }
const _hoisted_23 = { class: "font-semibold flex flex-row justify-end w-full text-right" }
const _hoisted_24 = { class: "flex flex-row justify-between items-baseline mb-2" }
const _hoisted_25 = { class: "flex w-full flex-row justify-start" }
const _hoisted_26 = { class: "font-semibold flex flex-row justify-end w-2/3" }
const _hoisted_27 = { class: "flex flex-row justify-between items-baseline mb-2" }
const _hoisted_28 = { class: "flex w-full flex-row justify-start" }
const _hoisted_29 = { class: "font-semibold flex flex-row justify-end w-2/3" }
const _hoisted_30 = { class: "flex flex-row justify-between items-baseline mb-2" }
const _hoisted_31 = { class: "flex w-full flex-row justify-start" }
const _hoisted_32 = { class: "font-semibold flex flex-row justify-end w-full" }
const _hoisted_33 = { class: "flex flex-row justify-between items-baseline mb-2" }
const _hoisted_34 = { class: "flex w-full flex-row justify-start" }
const _hoisted_35 = { class: "font-semibold flex flex-row justify-end w-full text-right" }
const _hoisted_36 = { class: "flex flex-row justify-between items-baseline mb-2" }
const _hoisted_37 = { class: "flex w-full flex-row justify-start" }
const _hoisted_38 = { class: "font-semibold flex flex-row justify-end w-full" }
const _hoisted_39 = { class: "w-36" }
const _hoisted_40 = { class: "w-full flex flex-row items-center" }
const _hoisted_41 = { class: "w-36 mr-4" }
const _hoisted_42 = { class: "w-36" }
const _hoisted_43 = { class: "w-full flex flex-row items-center" }
const _hoisted_44 = { class: "w-36 mr-4" }
const _hoisted_45 = { class: "w-36" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_Title = _resolveComponent("Title")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_Select = _resolveComponent("Select")!
  const _component_PickupCorporateAddressSection = _resolveComponent("PickupCorporateAddressSection")!
  const _component_MultipleSelectProduct = _resolveComponent("MultipleSelectProduct")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_Repetable = _resolveComponent("Repetable")!
  const _component_TimeRangePickerV2 = _resolveComponent("TimeRangePickerV2")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_button_outline = _resolveComponent("button-outline")!
  const _component_SavedAddressList = _resolveComponent("SavedAddressList")!
  const _component_ModalAddNewAddress = _resolveComponent("ModalAddNewAddress")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock(_component_DetailLayout, {
    "on-back": _ctx.onBack,
    title: 
      _ctx.isEditPage
        ? _ctx.$t('pickupCorporate.titleEditConfig')
        : _ctx.$t('pickupCorporate.titleCreateConfig')
    ,
    "vertical-separator": false,
    loading: _ctx.apiDetailData.loading,
    error: !!_ctx.apiDetailData.errorType,
    "error-type": _ctx.apiDetailData.errorType
  }, {
    "top-right": _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_button_fill, {
          title: _ctx.$t('pickupCorporate.save'),
          class: "bg-red-lp-300 px-8",
          "is-disabled": !_ctx.isFormValid || _ctx.isLoadingSubmit,
          onClick: _cache[1] || (_cache[1] = 
            () => {
              _ctx.isEditPage ? _ctx.onConfirmEdit() : _ctx.onSubmit();
            }
          )
        }, null, 8, ["title", "is-disabled"])
      ])
    ]),
    data: _withId(() => [
      _createVNode("main", _hoisted_2, [
        _createVNode("section", _hoisted_3, [
          _createVNode(_component_Title, {
            label: _ctx.$t('pickupCorporate.detailInfo')
          }, null, 8, ["label"]),
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_DataWrapper, {
              class: "w-full mr-6",
              label: _ctx.$t('pickupCorporate.configName'),
              asterisk: "",
              style: {"flex":"1"}
            }, {
              default: _withId(() => [
                _createVNode(_component_lp_input, {
                  modelValue: _ctx.form.name,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.name = $event)),
                  placeholder: _ctx.$t('pickupCorporate.placeholderConfigName'),
                  "max-length": 50
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_DataWrapper, {
              class: "w-full mr-4",
              label: _ctx.$t('pickupCorporate.clientRef'),
              asterisk: "",
              style: {"flex":"1"}
            }, {
              default: _withId(() => [
                _createVNode(_component_SelectSearch, {
                  class: ["mt-1.5 h-10 client-ref", [{ disabled: _ctx.isEditPage || _ctx.isClientBranch }]],
                  options: _ctx.clientOptions,
                  modelValue: _ctx.form.clientId,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.clientId = $event)),
                  "is-server-side": true,
                  "is-loading": _ctx.clientController.isLoading,
                  "key-value": 'name',
                  placeholder: _ctx.$t('pickupCorporate.placeholderClient'),
                  "is-disabled": _ctx.isClientBranch || _ctx.isEditPage,
                  onFilter: _ctx.onSearchClient,
                  onChange: _ctx.onSelectClient
                }, null, 8, ["class", "options", "modelValue", "is-loading", "placeholder", "is-disabled", "onFilter", "onChange"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_DataWrapper, {
              class: "w-full",
              label: _ctx.$t('pickupCorporate.the3lcPickUp'),
              asterisk: "",
              style: {"flex":"1"}
            }, {
              default: _withId(() => [
                _createVNode(_component_Select, {
                  class: "mt-1.5 lettercode-select",
                  "custom-class": "mr-0",
                  "data-select": _ctx.letterCodeOptions,
                  value: _ctx.form.cityId,
                  isDisabled: true
                }, null, 8, ["data-select", "value"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          (!_ctx.apiDetailData.loading)
            ? (_openBlock(), _createBlock(_component_PickupCorporateAddressSection, {
                key: 0,
                ref: "PickupCorporateAddressSection",
                "is-internal": _ctx.isAdmin,
                "is-edit": _ctx.isEditPage,
                "client-id": Number(_ctx.form.clientId.value),
                onOnClickTambahAlamat: _ctx.onClickTambahAlamat,
                onOnAddressListUpdated: _ctx.onAddressListUpdated,
                onOnClickPilihAlamatLain: _ctx.onClickPilihAlamatLain
              }, null, 8, ["is-internal", "is-edit", "client-id", "onOnClickTambahAlamat", "onOnAddressListUpdated", "onOnClickPilihAlamatLain"]))
            : _createCommentVNode("", true),
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('pickupCorporate.courierNote'),
            class: "mb-8",
            optional: ""
          }, {
            default: _withId(() => [
              _createVNode(_component_lp_input, {
                modelValue: _ctx.form.courierNote,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.courierNote = $event)),
                placeholder: _ctx.$t('pickupCorporate.placeholderCourierNote'),
                type: "textarea",
                "text-area-rows": "3",
                "max-length": 255,
                "show-max-length": ""
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _createVNode("section", _hoisted_5, [
          _createVNode(_component_Title, {
            label: _ctx.$t('pickupCorporate.fleetAndSchedule'),
            class: "mb-8"
          }, null, 8, ["label"]),
          _createVNode("div", _hoisted_6, [
            _createVNode(_component_DataWrapper, {
              class: "mr-4",
              label: _ctx.$t('pickupCorporate.vehicleType'),
              asterisk: "",
              style: {"flex":"1"}
            }, {
              default: _withId(() => [
                _createVNode(_component_Select, {
                  class: "mt-2",
                  "data-select": _ctx.transportTypeOptions,
                  value: _ctx.form.transportType,
                  "is-open-menu": _ctx.isTransportTypeSelectOpen,
                  "on-open-select": 
                  () => {
                    _ctx.isTransportTypeSelectOpen = true;
                  }
                ,
                  "on-close-select": 
                  () => {
                    _ctx.isTransportTypeSelectOpen = false;
                  }
                ,
                  "on-choose-select": 
                  (_name, val) => {
                    _ctx.form.transportType = val;
                  }
                
                }, null, 8, ["data-select", "value", "is-open-menu", "on-open-select", "on-close-select", "on-choose-select"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('pickupCorporate.serviceType'),
              asterisk: "",
              style: {"flex":"1"}
            }, {
              default: _withId(() => [
                _createVNode(_component_MultipleSelectProduct, {
                  class: "mt-2",
                  modelValue: _ctx.form.serviceCode,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.serviceCode = $event)),
                  status: "active",
                  disabledJumboPackH2h: "true",
                  "note-for-bosspack": true,
                  "disabled-bosspack": _ctx.disabledBosspack,
                  placeholder: _ctx.$t('pickupCorporate.placeholderService')
                }, null, 8, ["modelValue", "disabled-bosspack", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode(_component_DataWrapper, {
              class: "mr-6",
              label: _ctx.$t('pickupCorporate.estimateTonase'),
              asterisk: "",
              style: {"flex":"1"}
            }, {
              default: _withId(() => [
                _createVNode(_component_lp_input, {
                  modelValue: _ctx.form.estimateTotalTonase,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.estimateTotalTonase = $event)),
                  placeholder: _ctx.$t('pickupCorporate.placeholderEstimateTonase'),
                  suffix: "kg",
                  type: "number"
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('pickupCorporate.estimateKoli'),
              asterisk: "",
              style: {"flex":"1"}
            }, {
              default: _withId(() => [
                _createVNode(_component_lp_input, {
                  modelValue: _ctx.form.estimateTotalKoli,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.estimateTotalKoli = $event)),
                  placeholder: _ctx.$t('pickupCorporate.placeholderEstimateKoli'),
                  type: "number"
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_DataWrapper, {
              class: "mr-6",
              label: _ctx.$t('pickupCorporate.dateStartPickUp'),
              asterisk: "",
              style: {"flex":"1"}
            }, {
              default: _withId(() => [
                _createVNode(_component_DatePicker, {
                  class: "mt-2",
                  modelValue: _ctx.form.start,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.start = $event)),
                  "min-date": _ctx.minDate,
                  onSelected: _ctx.onSelectStartDate,
                  placeholder: _ctx.$t('pickupCorporate.selecDate')
                }, null, 8, ["modelValue", "min-date", "onSelected", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('pickupCorporate.dateEndPickUp'),
              style: {"flex":"1"},
              asterisk: ""
            }, {
              default: _withId(() => [
                _createVNode("div", null, [
                  _createVNode(_component_DatePicker, {
                    class: "mt-2",
                    modelValue: _ctx.form.end,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.form.end = $event)),
                    "min-date": _ctx.minDate,
                    "is-error": !_ctx.isEndDateMoreThanStartDate,
                    placeholder: _ctx.$t('pickupCorporate.selecDate')
                  }, null, 8, ["modelValue", "min-date", "is-error", "placeholder"]),
                  (!_ctx.isEndDateMoreThanStartDate)
                    ? (_openBlock(), _createBlock("div", _hoisted_9, _toDisplayString(_ctx.$t("pickupCorporate.validationEndBeforeStart")), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createVNode(_component_Repetable, {
            class: "mb-8",
            "days-value": _ctx.form.repeatDays,
            "interval-value": _ctx.form.intervalWeek,
            onSetInterval: _cache[10] || (_cache[10] = 
              (val) => {
                _ctx.form.intervalWeek = val;
              }
            ),
            onSetDays: _cache[11] || (_cache[11] = 
              (val) => {
                _ctx.form.repeatDays = val;
              }
            )
          }, null, 8, ["days-value", "interval-value"]),
          _createVNode("div", _hoisted_10, [
            _createVNode(_component_DataWrapper, {
              class: "relative mr-6",
              label: _ctx.$t('pickupCorporate.timePickUp'),
              asterisk: "",
              style: {"flex":"1"}
            }, {
              default: _withId(() => [
                _createVNode(_component_TimeRangePickerV2, {
                  class: "mt-2",
                  modelValue: _ctx.form.time,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.form.time = $event)),
                  titlePickup: _ctx.$t('Pilih jam Pick Up'),
                  placeholder: _ctx.$t('pickupCorporate.placeholderTime')
                }, null, 8, ["modelValue", "titlePickup", "placeholder"]),
                _createVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("pickupCorporate.maxPickupTime")), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode("div", _hoisted_12, [
              (_ctx.form.start && _ctx.form.time)
                ? (_openBlock(), _createBlock("div", _hoisted_13, [
                    _hoisted_14,
                    _createTextVNode(" " + _toDisplayString(_ctx.pickupTimeLabel), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        (_ctx.showModalSuccess)
          ? (_openBlock(), _createBlock(_component_Modal, _mergeProps({ key: 0 }, _ctx.modalMessageEntities, { "custom-width": "430px" }), {
              custom: _withId(() => [
                _createVNode("section", null, [
                  _createVNode("h5", _hoisted_15, " \"" + _toDisplayString(_ctx.form.clientId.name) + "\" " + _toDisplayString(_ctx.isEditPage
                    ? _ctx.$t("pickupCorporate.modalSuccessConfigTitleUpdated")
                    : _ctx.$t("pickupCorporate.modalSuccessConfigTitleCreated")), 1),
                  _createVNode("p", _hoisted_16, _toDisplayString(_ctx.isEditPage
                    ? _ctx.$t("pickupCorporate.modalSuccessConfigUpdated")
                    : _ctx.$t("pickupCorporate.modalSuccessConfigCreated")), 1)
                ]),
                _createVNode("section", _hoisted_17, [
                  _createVNode("div", _hoisted_18, [
                    _createVNode("div", _hoisted_19, _toDisplayString(_ctx.$t("pickupCorporate.transportType")), 1),
                    _createVNode("div", _hoisted_20, _toDisplayString(_ctx.pickupScheduleSuccessModalData.transportType), 1)
                  ]),
                  _createVNode("div", _hoisted_21, [
                    _createVNode("div", _hoisted_22, _toDisplayString(_ctx.$t("pickupCorporate.serviceType")), 1),
                    _createVNode("div", _hoisted_23, _toDisplayString(_ctx.pickupScheduleSuccessModalData.serviceCodes), 1)
                  ]),
                  _createVNode("div", _hoisted_24, [
                    _createVNode("div", _hoisted_25, _toDisplayString(_ctx.$t("pickupCorporate.tanggalMulaiPickup")), 1),
                    _createVNode("div", _hoisted_26, _toDisplayString(_ctx.pickupScheduleSuccessModalData.start), 1)
                  ]),
                  _createVNode("div", _hoisted_27, [
                    _createVNode("div", _hoisted_28, _toDisplayString(_ctx.$t("pickupCorporate.tanggalBerakhirPickup")), 1),
                    _createVNode("div", _hoisted_29, _toDisplayString(_ctx.pickupScheduleSuccessModalData.end), 1)
                  ]),
                  _createVNode("div", _hoisted_30, [
                    _createVNode("div", _hoisted_31, _toDisplayString(_ctx.$t("pickupCorporate.pickupInterval")), 1),
                    _createVNode("div", _hoisted_32, _toDisplayString(_ctx.pickupScheduleSuccessModalData.pickupInterval) + " " + _toDisplayString(_ctx.$t("pickupCorporate.weekOnce")), 1)
                  ]),
                  _createVNode("div", _hoisted_33, [
                    _createVNode("div", _hoisted_34, _toDisplayString(_ctx.$t("pickupCorporate.hariPickup")), 1),
                    _createVNode("div", _hoisted_35, _toDisplayString(_ctx.pickupScheduleSuccessModalData.pickupRepeatDays), 1)
                  ]),
                  _createVNode("div", _hoisted_36, [
                    _createVNode("div", _hoisted_37, _toDisplayString(_ctx.$t("pickupCorporate.jamPickup")), 1),
                    _createVNode("div", _hoisted_38, _toDisplayString(_ctx.pickupScheduleSuccessModalData.timePickup), 1)
                  ])
                ])
              ]),
              "custom-button": _withId(() => [
                _createVNode("div", _hoisted_39, [
                  _createVNode(_component_lp_button, {
                    class: "text-white",
                    "is-width-full": "",
                    "font-bold": "",
                    title: _ctx.$t('pickupCorporate.ok'),
                    onClick: _ctx.onCloseModalSucces
                  }, null, 8, ["title", "onClick"])
                ])
              ]),
              _: 1
            }, 16))
          : _createCommentVNode("", true),
        (_ctx.showModalFailed)
          ? (_openBlock(), _createBlock(_component_Modal, _mergeProps({ key: 1 }, _ctx.modalErrorMessageEntities), {
              "custom-button": _withId(() => [
                _createVNode("div", _hoisted_40, [
                  _createVNode("div", _hoisted_41, [
                    _createVNode(_component_button_outline, {
                      "is-width-full": "",
                      "font-bold": "",
                      title: _ctx.failedModalBackLabel,
                      onClick: _cache[13] || (_cache[13] = 
                    () => {
                      _ctx.showModalFailed = false;
                    }
                  )
                    }, null, 8, ["title"])
                  ]),
                  _createVNode("div", _hoisted_42, [
                    _createVNode(_component_lp_button, {
                      class: "text-white",
                      "is-width-full": "",
                      "font-bold": "",
                      title: _ctx.failedModalRetryLabel,
                      onClick: _ctx.onSubmit
                    }, null, 8, ["title", "onClick"])
                  ])
                ])
              ]),
              _: 1
            }, 16))
          : _createCommentVNode("", true),
        (_ctx.showModalConfirm)
          ? (_openBlock(), _createBlock(_component_Modal, _mergeProps({ key: 2 }, _ctx.modalConfirmEntities), {
              "custom-button": _withId(() => [
                _createVNode("div", _hoisted_43, [
                  _createVNode("div", _hoisted_44, [
                    _createVNode(_component_button_outline, {
                      "is-width-full": "",
                      "font-bold": "",
                      title: _ctx.$t('pickupCorporate.back'),
                      onClick: _cache[14] || (_cache[14] = 
                    () => {
                      _ctx.showModalConfirm = false;
                    }
                  )
                    }, null, 8, ["title"])
                  ]),
                  _createVNode("div", _hoisted_45, [
                    _createVNode(_component_lp_button, {
                      class: "text-white",
                      "is-width-full": "",
                      "font-bold": "",
                      title: _ctx.$t('pickupCorporate.save'),
                      onClick: _ctx.onSubmit
                    }, null, 8, ["title", "onClick"])
                  ])
                ])
              ]),
              _: 1
            }, 16))
          : _createCommentVNode("", true),
        (_ctx.isSavedAddressListOpen)
          ? (_openBlock(), _createBlock(_component_SavedAddressList, {
              key: 3,
              isShown: _ctx.isSavedAddressListOpen,
              "onUpdate:isShown": _cache[15] || (_cache[15] = ($event: any) => (_ctx.isSavedAddressListOpen = $event)),
              onSelectAddress: _ctx.onSelectAddress,
              onUpdateDefaultAddress: _cache[16] || (_cache[16] = ($event: any) => (_ctx.updateListPickupCorporateAddress(false))),
              onAddressDeleted: _cache[17] || (_cache[17] = ($event: any) => (_ctx.updateListPickupCorporateAddress(true))),
              clientId: Number(_ctx.form.clientId.value),
              selectedAddress: _ctx.selectedAddress
            }, null, 8, ["isShown", "onSelectAddress", "clientId", "selectedAddress"]))
          : _createCommentVNode("", true),
        _withDirectives(_createVNode(_component_ModalAddNewAddress, {
          formType: "add",
          isVisible: _ctx.isAddAddressOpen,
          onClose: _ctx.onClickTambahAlamat,
          onOnSuccess: _ctx.onSuccessTambahAlamat,
          clientId: Number(_ctx.form.clientId.value),
          forceDefault: true
        }, null, 8, ["isVisible", "onClose", "onOnSuccess", "clientId"]), [
          [_vShow, _ctx.isAddAddressOpen]
        ])
      ])
    ]),
    _: 1
  }, 8, ["on-back", "title", "loading", "error", "error-type"]))
})